import styled from 'styled-components';

export const ResearchContainer = styled.div`
  padding: 2rem;
`;

export const SectionTitle = styled.h2`
  color: #003366;
  margin-bottom: 1rem;
`;

export const SectionContent = styled.div`
  line-height: 1.6;
`;

export const Subsection = styled.div`
  margin-bottom: 2rem;
`;

export const SubsectionTitle = styled.h3`
  color: #0056b3;
`;

export const SubsectionContent = styled.p`
  margin-top: 0.5rem;
`;